import React from 'react'
import './Footer.css'
import Github from '../../assets/github.png'
import Instagram from '../../assets/instagram.png'
import Linkedin from '../../assets/linkedin.png'
import Logo from '../../assets/logo.png'




const Footer = () => {
  return (
    <div className="Footer-container">
      <hr />
      <div className="footer">
        <div className="social-links">
          <img src={Github} alt="Logo GitHub" />
          <img src={Instagram} alt="Logo Instagram" />
          <img src={Linkedin} alt="Logo Linkedin" />
        </div>
        <div className="logo-f">
          <img src={Logo} alt="Logo The Fit Club" />
        </div>
      </div>


      <div className="blur footer-blur-1"></div>
      <div className="blur footer-blur-mid"></div>
      <div className="blur footer-blur-2"></div>
    </div>
  )
}

export default Footer